import { render, staticRenderFns } from "./index-by-trx.vue?vue&type=template&id=11030af0&scoped=true"
import script from "./index-by-trx.vue?vue&type=script&lang=js"
export * from "./index-by-trx.vue?vue&type=script&lang=js"
import style0 from "./index-by-trx.vue?vue&type=style&index=0&id=11030af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11030af0",
  null
  
)

export default component.exports